"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var price_lookup_action_keys_1 = require("./price-lookup-action-keys");

exports.loginResponseAction = function (isAdmin, accountName) {
  var response = {
    accountName: accountName,
    isAdmin: isAdmin
  };
  return {
    payload: response,
    type: price_lookup_action_keys_1.PriceLookupActionKeys.LOGIN_RESPONSE
  };
};